/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import "babel-polyfill";
import "../stylesheets/application.scss";

import "../support/lodash";
import "../support/tags-input";
import "../libs/set_assumed_role";
import ReactRailsUJS from "react_ujs";

window.Routes = require('routes');

window.onunhandledrejection = d =>
  console.error("Unhandled Promise Rejection:", d);

// Support for react-rails:
// Support component names relative to this directory:
const componentRequireContext = require.context(
  "components",
  true,
  /pages\/.*|preloaded\/.*/
);
ReactRailsUJS.useContext(componentRequireContext);



// WEBPACK FOOTER //
// ./app/javascript/packs/application.js